import * as c3 from "c3"
import * as d3 from "d3"

const Charts = {
  initialize() {
    window.Registrations = window.Registrations || {}

    // other chart colors
    let baseColor = "#ffd466"
    let baseColor2 = "#f9b738"
    let baseColor3 = "#ffe6a6"
    let baseColor4 = "#fff3d4"
    // bar widths
    let barWidth = 30

    Registrations.Charts = {
      axisMoneyFormat(value) {
        if (value === 0) {
          return d3.format("$.1s")(value)
        } else {
          return d3.format("$,.2s")(value)
        }
      },

      moneyFormat(value) {
        return d3.format("$1,.2f")(value)
      },

      countFormat(value) {
        return d3.format(".0f")(value)
      },

      SimpleBarChartHorizontal(json, bindto) {
        let args = {
          bindto,
          data: {
            type: "bar",
            json: json.data,
            keys: { x: "dimension", value: json.groups },
            groups: [json.groups],
            colors: json.colors
          },
          bar: {
            width: {
              max: barWidth
            }
          },
          size: {
            height: 240
          },
          color: {
            pattern: [baseColor, baseColor2, baseColor3, baseColor4]
          },
          tooltip: {
            grouped: false,
            format: {
              title(d) {
                return null
              },
              value: this.moneyFormat
            }
          },
          grid: {
            focus: {
              show: false
            }
          },
          axis: {
            x: { type: "category", tick: { outer: false } },
            y: {
              tick: { format: this.axisMoneyFormat, count: 4, outer: false }
            },
            rotated: true
          },
          padding: {
            right: 10,
            top: 10
          },
          legend: { show: false }
        }
        return c3.generate(args)
      },

      StackedBarChartOverTime(json, bindto) {
        let args = {
          bindto,
          data: {
            type: "bar",
            json: json.data,
            keys: { x: "date", value: json.groups },
            groups: [json.groups],
            colors: json.colors
          },
          bar: {
            width: {
              max: barWidth
            }
          },
          color: {
            pattern: [baseColor, baseColor2, baseColor3, baseColor4]
          },
          padding: {
            bottom: 0
          },
          tooltip: {
            format: { value: this.moneyFormat },
            total: true
          },
          axis: {
            x: {
              type: "timeseries",
              tick: { format: Registrations.i18n.dateFormatD3, outer: false }
            },
            y: {
              tick: { format: this.axisMoneyFormat, count: 4, outer: false }
            }
          },

          legend: {
            hide: true
          }
        }
        return c3.generate(args)
      }
    }
  }
}

export default Charts
